var map = {
	"./de/gotoTOPbg.png": "xIcL",
	"./en/gotoTOPbg.png": "fU+2",
	"./es/gotoTOPbg.png": "DB5n",
	"./fr/gotoTOPbg.png": "L6UU",
	"./ja/gotoTOPbg.png": "n46Y",
	"./ko/gotoTOPbg.png": "f0DG",
	"./pt/gotoTOPbg.png": "0NFq",
	"./ru/gotoTOPbg.png": "BY4v",
	"./tc/gotoTOPbg.png": "Cd/x",
	"./th/gotoTOPbg.png": "1AW+"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ExQR";